module.exports = __webpack_public_path__ + "img/right-arrow.88c3b6fc.svg";